export default __webpack_public_path__ + "static/media/img-slider-smart-signage-2.72fc01c1.png";